exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3A6w5gDHPXcvOd{padding-top:12px;font-family:Helvetica Neue,Arial,Helvetica,sans-serif;font-size:12px;line-height:20px}._3A6w5gDHPXcvOd .RePlpPYxmGSa9l{color:#6b778c;text-decoration:none}._3A6w5gDHPXcvOd .RePlpPYxmGSa9l:hover{text-decoration:underline}._1KepOZHWd3kPd_{margin-top:8px;padding:6px 10px;border-radius:3px;background-color:#42548e;color:#fff;font-family:Helvetica Neue,Arial,Helvetica,sans-serif;font-size:12px;line-height:20px}._1KepOZHWd3kPd_ ._19pWPIH_TpTtzG{margin-top:14px}._1KepOZHWd3kPd_ ._19pWPIH_TpTtzG .RePlpPYxmGSa9l{color:#a5adba;text-decoration:none}._1KepOZHWd3kPd_ ._19pWPIH_TpTtzG .RePlpPYxmGSa9l:hover{text-decoration:underline}._1KepOZHWd3kPd_ p>a{color:#fff}", ""]);

// exports
exports.locals = {
	"whiteBox": "_3A6w5gDHPXcvOd",
	"feedbackLink": "RePlpPYxmGSa9l",
	"purpleBox": "_1KepOZHWd3kPd_",
	"feedbackLinkContainer": "_19pWPIH_TpTtzG"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3053/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/common/components/create-board/free-board-limit-info.less
// module id = rcf2
// module chunks = 24